// extracted by mini-css-extract-plugin
module.exports = {"rating":"Aj-z","numberOfStars":"Bj-z","count":"Cj-z"};